
import { v4 as uuidv4 } from 'uuid';

import { VueResourceHeaders } from './vue-resource.js';

const MAX_CALLS = 100;

// eslint-disable-next-line one-var
const BatchPromise = {

	call({ urls, data = [], itemsId }) {
		const postCallsBatchContents = this.post(urls.post, data.post, itemsId),
			getCallsBatchContents = this.get(urls.get),
			mergedCallsContent = this.mergeContent(postCallsBatchContents, getCallsBatchContents),
			fecthArray = mergedCallsContent.map((object) => {
				const payload = {
					method: 'POST',
					headers: object.header,
					body: object.content.join('\r\n'),
				};

				object.payload = payload;

				return object;
			}),
			dataReturn = Array(urls.get ? urls.get.length : 0);


		return new Promise((resolve, reject) => {
			Promise.all(fecthArray.map((call) => this.fetchCall(call)))
				.then((results) => {
					results.reduce((array, elements) => array.concat(...elements), []).forEach((d) => {
						if (urls.get) {
							const index = urls.get.findIndex((url) => d.url.includes(url));
							if (index !== -1) {
								dataReturn[index] = d.data;
							}
						} else {
							dataReturn.push(d);
						}
					});

					resolve(dataReturn);
				}).catch((e) => reject(e));
		});
	},

	fetchCall(call) {
		return new Promise((resolve, reject) => {
			fetch(`${call.fetchUrl}/_api/$batch`, call.payload)
				.then((response) => response.text())
				.then((data) => {
					let index = 0, responseInLines = data.split('\n'), results = [];
					for (let currentLine = 0; currentLine < responseInLines.length; currentLine++) {
						try {
							let { d } = JSON.parse(responseInLines[currentLine]),
								result = {};
							if (call.isGet) {
								result.url = call.arrayUrl[index++];
								result.data = d.results;
							} else {
								result = d;
							}
							results.push(result);
						} catch (e) { }
					}
					resolve(results);
				})
				.catch((e) => reject(e))
				.catch((e) => reject(e));
		});
	},

	get(urls) {
		if (!urls) {
			return [];
		}
		const getCallsBatchContents = urls.reduce((object, url) => {
			let key, site;

			key = site = url.split('/_api')[0];
			object[key] = object[key] || {};

			object[key].arrayUrl = object[key].arrayUrl || [];

			if (object[key].arrayUrl.length >= MAX_CALLS) {
				let cnt = 0;
				do {
					key = `${key}_part${cnt++}`;
					object[key] = object[key] || {};
					object[key].arrayUrl = object[key].arrayUrl || [];
				} while (object[key].arrayUrl.length >= MAX_CALLS);
			}

			object[key].arrayUrl.push(url);

			object[key].boundary = object[key].boundary || uuidv4();

			object[key].content = object[key].content || [];
			object[key].content.pop(); // to delete --batch_${object[key].boundary}-- included at ends
			object[key].content.push(`--batch_${object[key].boundary}`); // batch Init - guiid
			object[key].content.push('Content-Type: application/http');
			object[key].content.push('Content-Transfer-Encoding: binary');
			object[key].content.push('');
			object[key].content.push(`GET https://salicru.sharepoint.com/sites/intranet/${url} HTTP/1.1`);
			object[key].content.push('Accept: application/json;odata=verbose');
			object[key].content.push(`Authorization: Bearer ${VueResourceHeaders.token}`);
			object[key].content.push('');
			object[key].content.push(`--batch_${object[key].boundary}--`); // add ends batch mark

			object[key].header = object[key].header || {
				'Content-Type': `multipart/mixed; boundary=batch_${object[key].boundary}`,
				'X-RequestDigest': VueResourceHeaders.formDigestValue,//|| _spPageContextInfo.formDigestValue,
				'Authorization': `Bearer ${VueResourceHeaders.token}`,
				'Accept': 'application/json',
			};

			object[key].fetchUrl = object[key].fetchUrl || `https://salicru.sharepoint.com/sites/intranet${(site.includes('_api') ? '' : `/${site}`)}`;
			object[key].isGet = true;
			return object;
		}, {});

		return getCallsBatchContents;
	},

	mergeContent(postCallsBatchContents, getCallsBatchContents) {
		const getBatchEntries = Object.entries(getCallsBatchContents),
			postBatchEntries = Object.entries(postCallsBatchContents),
			mergedCallsContent = [];
		mergedCallsContent.push(...postBatchEntries.map((e) => e[1]));
		mergedCallsContent.push(...getBatchEntries.map((e) => e[1]));

		return mergedCallsContent;
	},

	post(urlsGroup, dataGroup, itemIdGroup) {
		if (!urlsGroup) {
			return [];
		}

		const postCallsBatchContents = urlsGroup.map((urls, index) => {
			let changeSetId = uuidv4(),
				boundary = uuidv4(),
				site = urls[0].split('/_api')[0],
				fetchUrl = `https://salicru.sharepoint.com/sites/intranet/${(site.includes('_api') ? '' : site)}`,
				batchContents = [],
				batchBody = null,
				header = {
					'Content-Type': `multipart/mixed; boundary=batch_${boundary}`,
					'X-RequestDigest': VueResourceHeaders.formDigestValue, //|| _spPageContextInfo.formDigestValue,
					'Authorization': `Bearer ${VueResourceHeaders.token}`,
					'Accept': 'application/json',
				},
				data = dataGroup[index],
				type = itemIdGroup[index] ? 'MERGE' : 'POST';

			for (let i = 0; i < data.length; i++) {
				let restCallUrl = urls[i],
					restCallData = data[i];

				batchContents.push(`--changeset_${changeSetId}`);
				batchContents.push('Content-Type: application/http');
				batchContents.push('Content-Transfer-Encoding: binary');
				batchContents.push('');
				batchContents.push(`${type} https://salicru.sharepoint.com/sites/intranet/${restCallUrl} HTTP/1.1`);
				batchContents.push('Accept: application/json;odata=verbose');
				batchContents.push('Content-Type: application/json;odata=verbose');
				batchContents.push(`Authorization: Bearer ${VueResourceHeaders.token}`);

				if (itemIdGroup[index] !== undefined) {
					batchContents.push('IF-MATCH: *');
				}

				batchContents.push('');
				batchContents.push(JSON.stringify(restCallData));
				batchContents.push('');
			}

			// END changeset to create data
			batchContents.push(`--changeset_${changeSetId}--`);
			// generate the body of the batch
			batchBody = batchContents.join('\r\n');

			// start with a clean array
			batchContents = [];

			batchContents.push(`--batch_${boundary}`);
			batchContents.push(`Content-Type: multipart/mixed; boundary=changeset_${changeSetId}`);
			batchContents.push(`Content-Length: ${batchBody.length}`);
			batchContents.push('Content-Transfer-Encoding: binary');
			batchContents.push('');
			batchContents.push(batchBody);
			batchContents.push('');

			return { content: batchContents, header, fetchUrl, isGet: false };
		});

		return postCallsBatchContents;
	},
};

export default BatchPromise;
